import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import DeveloperList from '../modules/developers/list';
import DeveloperAddEditView from '../modules/developers/addEditView';

const Developers: React.FC = () => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  return (
    <Routes>
      <Route path={AuthRoutes.developers}>
        <Route
          path={AuthRoutes.developers + RouteParamsTypes.blank}
          element={
            <ProtectedRoute
              component={DeveloperList}
              accessibleTo={[{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.developers + RouteParamsTypes.add}
          element={
            <ProtectedRoute
              component={DeveloperAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.developers + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={DeveloperAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.developers + RouteParamsTypes.view + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={DeveloperAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Developers]: [PermissionActionsEnum.View] }]}
            />
          }
        />
      </Route>

      <Route
        path={RouteParamsTypes.blank}
        element={
          <Navigate
            replace
            to={{
              pathname:
                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.developers) ||
                Modules.error + NonAuthRoutes.forbidden,
            }}
          />
        }
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Developers;
